import React from 'react'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  className?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', disabled, ...rest }, ref) => {
    const inputClasses = [
      'w-full px-4 py-3 bg-white border border-silver/60 rounded-warm font-body text-ink',
      'placeholder:text-ink-muted/50',
      'transition-all duration-200',
      'focus:border-green focus:ring-2 focus:ring-green/20 outline-none',
      disabled ? 'opacity-50 cursor-not-allowed bg-silver-light/50' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <div className="w-full">
        {label && (
          <label className="block font-body text-sm font-medium text-ink-light mb-1.5">
            {label}
          </label>
        )}
        <input ref={ref} disabled={disabled} className={inputClasses} {...rest} />
        {error && <p className="text-terra text-sm mt-1">{error}</p>}
      </div>
    )
  }
)

Input.displayName = 'Input'

export default Input
